// LOGIN
export const LOGIN_ACTIVE = 'LOGIN_ACTIVE'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_AUTHENTICATED = 'LOGIN_AUTHENTICATED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGGED_OUT = 'LOGGED_OUT'
export const LOGIN_RESET_STATUS = 'LOGIN_RESET_STATUS'
export const LOGIN_WITH_TEMP_PASSWORD = 'LOGIN_WITH_TEMP_PASSWORD'
export const LOGIN_WITH_TEMP_PASSWORD_SUCCESS =
  'LOGIN_WITH_TEMP_PASSWORD_SUCCESS'
export const SET_STORE_SUCCESS = 'SET_STORE_SUCCESS'
export const GET_ACTIVE_USER_SUCCESS = 'GET_ACTIVE_USER_SUCCESS'
export const REFRESHED_LOGIN_TOKEN_SUCCESS = 'REFRESHED_LOGIN_TOKEN_SUCCESS'
export const MOCKING_USER = 'MOCKING_USER'

// PASSWORD
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS'
export const SET_PASSWORD_FAILED = 'SET_PASSWORD_FAILED'
export const PASSWORD_RESET_STATUS = 'PASSWORD_RESET_STATUS'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED'
export const CLEAR_PASSWORD = 'CLEAR_PASSWORD'

// USER MANAGEMENT
export const STORE_USERS_SEARCHINFO = 'STORE_USER_SEARCHINFO'
export const STORE_USERS_ACTIVEINFO = 'STORE_USER_ACTIVEINFO'
export const STORE_USERS_LASTSORT = 'STORE_USERS_LASTSORT'
export const NEW_USER = 'NEW_USER'
export const GET_USER = 'GET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const CLEAR_USER = 'CLEAR_USER'
export const DELETE_USER = 'DELETE_USER'
export const LOAD_USERS = 'LOAD_USERS'
export const CLEAR_USERS = 'CLEAR_USERS'
export const LOAD_USER_ROLES = 'LOAD_USER_ROLES'
export const UPDATE_CURRENT_USER_PASSWORD = 'UPDATE_CURRENT_USER_PASSWORD'
export const CLEAR_USER_SEARCH_INFO = 'CLEAR_USER_SEARCH_INFO'

// STORE INFO
export const LOAD_REPRESENTATIVE = 'LOAD_REPRESENTATIVE'
export const LOAD_REPRESENTATIVES = 'LOAD_REPRESENTATIVES'
export const SEARCH_REPRESENTATIVES = 'SEARCH_REPRESENTATIVES'
export const LOAD_STORES = 'LOAD_STORES'
export const SEARCH_STORES = 'SEARCH_STORES'
export const LOAD_SELECTED_STORES = 'LOAD_SELECTED_STORES'
export const CLEAR_STORES = 'CLEAR_STORES'
export const CLEAR_SELECTED_STORES = 'CLEAR_SELECTED_STORES'
export const LOAD_STORE_SUCCESS = 'LOAD_STORE_SUCCESS'
export const LOAD_SELECTED_STORE_SUCCESS = 'LOAD_SELECTED_STORE_SUCCESS'
export const CLEAR_SELECTED_STORE = 'CLEAR_SELECTED_STORE'
export const LOADING_INVOICE_NUMBER = 'LOADING_INVOICE_NUMBER'
export const LOAD_INVOICE_NUMBER = 'LOAD_INVOICE_NUMBER'
export const HAS_INVOICE_NUMBER = 'HAS_INVOICE_NUMBER'
export const LOAD_CURRENT_STORE_DEBIT_DISABLED =
  'LOAD_CURRENT_STORE_DEBIT_DISABLED'
// SETTINGS
export const SETTINGS_HISTORY_SUCCESS = 'SETTINGS_HISTORY_SUCCESS'
export const LOADING_SETTINGS_HISTORY = 'LOADING_SETTINGS_HISTORY'
export const PAYMENT_INFO_SUCCESS = 'PAYMENT_INFO_SUCCESS'
export const LOADING_CHECKOUT_SETTINGS = 'LOADING_CHECKOUT_SETTINGS'
export const LOAD_CHECKOUT_STYLING_SUCCESS = 'LOAD_CHECKOUT_STYLING_SUCCESS'
export const LOAD_TERMS_LINKS_SUCCESS = 'LOAD_TERMS_LINKS_SUCCESS'
export const EMPTY_TERMS_LINKS = 'EMPTY_TERMS_LINKS'
export const PUSH_OUT_AUTOMATIC_DEBIT = 'PUSH_OUT_AUTOMATIC_DEBIT'

// INVOICE DATA
export const LOADING_INVOICE_DATA = 'LOADING_INVOICE_DATA'
export const LOAD_INVOICE_DATA_SUCCESS = 'LOAD_INVOICE_DATA_SUCCESS'
export const SET_INVOICE_DATA_SUCCESS = 'SET_INVOICE_DATA_SUCCESS'
export const EMPTY_INVOICE_DATA = 'EMPTY_INVOICE_DATA'

// LOGOTYPE
export const LOADING_LOGOTYPE = 'LOADING_LOGOTYPE'
export const LOAD_LOGOTYPE_SUCCESS = 'LOAD_LOGOTYPE_SUCCESS'
export const SET_LOGOTYPE_SUCCESS = 'SET_LOGOTYPE_SUCCESS'
export const EMPTY_LOGOTYPE = 'EMPTY_LOGOTYPE'

// PAYMENT METHODS
export const LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS =
  'LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS'
export const PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS =
  'PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS'

// STORE SETTINGS
export const LOADING_REPRESENTATIVE_DETAILS = 'LOADING_REPRESENTATIVE_DETAILS'

// NOTIFICATIONS
export const NOTIFY_DEFAULT = 'NOTIFY_DEFAULT'
export const NOTIFY_PRIMARY = 'NOTIFY_PRIMARY'
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS'
export const NOTIFY_WARNING = 'NOTIFY_WARNING'
export const NOTIFY_DANGER = 'NOTIFY_DANGER'
export const NOTIFY_RESET = 'NOTIFY_RESET'

// BATCH IMPORT USERS
export const BATCH_IMPORT_ACTIVE = 'BATCH_IMPORT_ACTIVE'
export const BATCH_IMPORT_FAILED = 'BATCH_IMPORT_FAILED'
export const BATCH_IMPORT_SUCCESS = 'BATCH_IMPORT_SUCCESS'
export const CLEAR_PREVIOUS_IMPORT = 'CLEAR_PREVIOUS_IMPORT'

// PAY APPLY
export const PAY_APPLY_INIT = 'PAY_APPLY_INIT'
export const PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD =
  'PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD'
export const PAY_APPLY_SET_STEP = 'PAY_APPLY_SET_STEP'
export const PAY_APPLY_SET_PAGE = 'PAY_APPLY_SET_PAGE'
export const PAY_APPLY_GOVERNMENT_ID = 'PAY_APPLY_GOVERNMENT_ID'
export const PAY_APPLY_GET_ADDRESS_INFO = 'PAY_APPLY_GET_ADDRESS_INFO'
export const PAY_APPLY_GET_PAYMENT_METHODS = 'PAY_APPLY_GET_PAYMENT_METHODS'
export const PAY_APPLY_SELECT_PAYMENT_METHOD = 'PAY_APPLY_SELECT_PAYMENT_METHOD'
export const PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD =
  'PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD'
export const PAY_APPLY_SET_PAYMENT_DATA = 'PAY_APPLY_SET_PAYMENT_DATA'
export const PAY_APPLY_SET_ORDER = 'PAY_APPLY_SET_ORDER'
export const PAY_APPLY_CREATE_APPLICATION_SUCCESS =
  'PAY_APPLY_CREATE_APPLICATION_SUCCESS'
export const PAY_APPLY_APPLY_APPLICATION_SUCCESS =
  'PAY_APPLY_APPLY_APPLICATION_SUCCESS'
export const PAY_APPLY_CREATE_PAYMENT_SUCCESS =
  'PAY_APPLY_CREATE_PAYMENT_SUCCESS'
export const PAY_APPLY_AUTH_PAYMENT_SUCCESS = 'PAY_APPLY_AUTH_PAYMENT_SUCCESS'
export const PAY_APPLY_DEBIT_PAYMENT_SUCCESS = 'PAY_APPLY_DEBIT_PAYMENT_SUCCESS'
export const PAY_APPLY_FORM_SPEC = 'PAY_APPLY_FORM_SPEC'
export const PAY_APPLY_NEW_PAGE_LOADING = 'PAY_APPLY_NEW_PAGE_LOADING'
export const PAY_APPLY_ON_PAGE_LOADING = 'PAY_APPLY_ON_PAGE_LOADING'
export const PAY_APPLY_REDIRECTION_DATA_SUCCESS =
  'PAY_APPLY_REDIRECTION_DATA_SUCCESS'
export const PAY_APPLY_CLEAR_REDIRECTION = 'PAY_APPLY_CLEAR_REDIRECTION'
export const PAY_APPLY_PAPER_SIGN = 'PAY_APPLY_PAPER_SIGN'
export const PAY_APPLY_SIGNING_STATUS = 'PAY_APPLY_SIGNING_STATUS'
export const PAY_APPLY_IDENTIFICATION_STATUS = 'PAY_APPLY_IDENTIFICATION_STATUS'
export const PAY_APPLY_MANUAL_IDENTIFICATION = 'PAY_APPLY_MANUAL_IDENTIFICATION'
export const PAY_APPLY_FAILED_SIGNING = 'PAY_APPLY_FAILED_SIGNING'
export const PAY_APPLY_FAILED_IDENTIFICATION = 'PAY_APPLY_FAILED_IDENTIFICATION'
export const PAY_APPLY_FORM_SPEC_DATA = 'PAY_APPLY_FORM_SPEC_DATA'
export const PAY_APPLY_FATAL_ERROR = 'PAY_APPLY_FATAL_ERROR'
export const PAY_APPLY_COAPPLICANT_INFO = 'PAY_APPLY_COAPPLICANT_INFO'
export const PAY_APPLY_SKIP_SIGNING = 'PAY_APPLY_SKIP_SIGNING'
export const PAY_APPLY_GET_PAYMENT_PER_MONTH = 'PAY_APPLY_GET_PAYMENT_PER_MONTH'
export const PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS =
  'PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS'
export const PAY_APPLY_GET_STORE_PAYMENT_METHODS =
  'PAY_APPLY_GET_STORE_PAYMENT_METHODS'
export const PAY_APPLY_COST_LOADING = 'PAY_APPLY_COST_LOADING'
export const PAY_APPLY_PENDING_APPLICATIONS_SUCCESS =
  'PAY_APPLY_PENDING_APPLICATIONS_SUCCESS'
export const PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS =
  'PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS'
export const PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS =
  'PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS'
export const PAY_APPLY_CUSTOMER_TYPE = 'PAY_APPLY_CUSTOMER_TYPE'
export const PAY_APPLY_SET_CUSTOMER_TYPE = 'PAY_APPLY_SET_CUSTOMER_TYPE'
export const PAY_APPLY_SET_DEBIT_AMOUNT = 'PAY_APPLY_SET_DEBIT_AMOUNT'
export const PAY_APPLY_SET_DEBIT_REFERENCE = 'PAY_APPLY_SET_DEBIT_REFERENCE'
export const PAY_APPLY_GET_PAYMENT = 'PAY_APPLY_GET_PAYMENT'
export const PAY_APPLY_GET_APPLICATION = 'PAY_APPLY_GET_APPLICATION'
export const PAY_APPLY_SET_PERIOD_OF_REPAYMENT =
  'PAY_APPLY_SET_PERIOD_OF_REPAYMENT'
export const PAY_APPLY_RESET_COST_ALTERNATIVES =
  'PAY_APPLY_RESET_COST_ALTERNATIVES'
export const PAY_APPLY_PUSHED_OUT_TO_CUSTOMER =
  'PAY_APPLY_PUSHED_OUT_TO_CUSTOMER'

// TRANSACTIONS
export const RESET_TRANSACTIONS = 'RESET_TRANSACTIONS'
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS'
export const TRANSACTION_DEBIT_LOADING = 'TRANSACTION_DEBIT_LOADING'

// TRANSACTION
export const SET_CURRENT_TRANSACTION_ID = 'SET_CURRENT_TRANSACTION_ID'
export const SET_TERMINAL_TRANSACTION = 'SET_TERMINAL_TRANSACTION'
export const GET_TRANSACTION_DETAILS = 'GET_TRANSACTION_DETAILS'
export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS'
export const CREDIT_TRANSACTION_SUCCESS = 'CREDIT_TRANSACTION_SUCCESS'

export const GET_CART_SUMMARY_SUCCESS = 'GET_CART_SUMMARY_SUCCESS'
export const GET_CART_SUMMARY_FAILED = 'GET_CART_SUMMARY_FAILED'

export const TRANSACTION_DETAILS_ACTION_ACTIVE =
  'TRANSACTION_DETAILS_ACTION_ACTIVE'
export const TRANSACTION_DETAILS_ACTION_FAILED =
  'TRANSACTION_DETAILS_ACTION_FAILED'
export const TRANSACTION_DETAILS_ACTION_SUCCESS =
  'TRANSACTION_DETAILS_ACTION_SUCCESS'
export const TRANSACTION_HAS_INVOICE_REF_SUCCESS =
  'TRANSACTION_HAS_INVOICE_REF_SUCCESS'
export const TRANSACTION_HAS_INVOICE_REF_FAILED =
  'TRANSACTION_HAS_INVOICE_REF_FAILED'
export const TRANSACTION_HAS_INVOICE_REF_ACTIVE =
  'TRANSACTION_HAS_INVOICE_REF_ACTIVE'
export const TRANSACTION_HAS_INVOICE_REF_CANCEL =
  'TRANSACTION_HAS_INVOICE_REF_CANCEL'

// CHAT
export const CHAT_FORM_OPENED = 'CHAT_FORM_OPENED'
export const CHAT_TOKEN = 'CHAT_TOKEN'
export const CHAT_REQUESTED = 'CHAT_REQUESTED'
export const CHAT_STARTED = 'CHAT_STARTED'
export const CHAT_NEW_MESSAGE = 'CHAT_NEW_MESSAGE'
export const CHAT_CLEAR = 'CHAT_CLEAR'
export const CHAT_SYSTEM_MESSAGE = 'CHAT_SYSTEM_MESSAGE'
export const CHAT_PEN_STATE = 'CHAT_PEN_STATE'
export const CHAT_QUEUED = 'CHAT_QUEUED'
export const CHAT_FINISHED = 'CHAT_FINISHED'
export const CHAT_ENTRANCE_CLOSED = 'CHAT_ENTRANCE_CLOSED'
export const CHAT_MINIMIZE = 'CHAT_MINIMIZE'
export const CHAT_API_INITIALIZED = 'CHAT_API_INITIALIZED'
export const CHAT_CLOSE_WARNING = 'CHAT_CLOSE_WARNING'
export const CHAT_MESSAGE_SENT = 'CHAT_MESSAGE_SENT'

// NEWS
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS'
export const GET_NEWS_FAILURE = 'GET_NEWS_FAILURE'
export const GET_NEWS_ARTICLE_SUCCESS = 'GET_NEWS_ARTICLE_SUCCESS'
export const CLEAR_NEWS_ARTICLE = 'CLEAR_NEWS_ARTICLE'

// STATISTICS
export const STATISTICS_GET_CHART = 'STATISTICS_GET_CHART'
export const STATISTICS_GET_TOPLIST = 'STATISTICS_GET_TOPLIST'
export const STATISTICS_GET_TREND = 'STATISTICS_GET_TREND'
export const STATISTICS_GET_STATUS = 'STATISTICS_GET_STATUS'

// Bonus checks
export const BONUS_SEARCH_LOADING = 'BONUS_SEARCH_LOADING'
export const HAS_BONUS_CHECK_SUPPORT_SUCCESS = 'HAS_BONUS_CHECK_SUPPORT_SUCCESS'
export const GET_BONUS_CHECKS_SUCCESS = 'GET_BONUS_CHECKS_SUCCESS'
export const REDEEM_BONUS_CHECK_SUCCESS = 'REDEEM_BONUS_CHECK_SUCCESS'
export const REDEEM_BONUS_CHECK_BY_REFERENCE_NUMBER_SUCCESS =
  'REDEEM_BONUS_CHECK_BY_REFERENCE_NUMBER_SUCCESS'
export const CLEAR_REDEEM_RESULT = 'CLEAR_REDEEM_RESULT'
export const UPDATE_BONUS_CHECK = 'UPDATE_BONUS_CHECK'
export const CLEAR_BONUS_CHECKS = 'CLEAR_BONUS_CHECKS'
export const CLEAR_BONUS_CHECK = 'CLEAR_BONUS_CHECK'
export const GET_BONUS_CHECK_SUCCESS = 'GET_BONUS_CHECK_SUCCESS'

// APP COMMONS
export const APP_INFO = 'APP_INFO'

// APPLICATION LINKS
export const LOAD_APPLICATION_LINKS = 'LOAD_APPLICATION_LINKS'
